import Cookies from 'js-cookie'

const Id = 'User-Id'
const UserName = 'User-Name'
const Token = 'Eduction-Token'

export function getToken () {
  return Cookies.get(Token)
}

export function setToken (token, expire) {
  if (expire) {
    return Cookies.set(Token, token, { expires: new Date(Number(expire) + 8 * 3600 * 1000) })
  } else {
    return Cookies.set(Token, token)
  }
}

export function removeToken () {
  return Cookies.remove(Token)
}

export function getId () {
  return Cookies.get(Id)
}

export function setId (id) {
  return Cookies.set(Id, id)
}

export function removeId () {
  return Cookies.remove(Id)
}

export function getUserName () {
  return Cookies.get(UserName)
}

export function setUserName (id) {
  return Cookies.set(UserName, id)
}
export function setAvatar (url) {
  return Cookies.set('avatar', url)
}
export function getAvatar () {
  return Cookies.get('avatar')
}
export function removeAvatar () {
  return Cookies.remove('avatar')
}

export function removeUserName () {
  return Cookies.remove(UserName)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js